import { buildWorkspacePath } from "@/utils/workspaceRoutes"

export function buildCoviOrganizationPath(
  path: string,
  organizationSlug: string | null,
  workspaceId?: string | null,
): string | undefined {
  if (!organizationSlug) {
    return undefined
  }

  let normalizedPath = path
  if (normalizedPath && !normalizedPath.startsWith("/")) {
    normalizedPath = `/${normalizedPath}`
  }

  if (workspaceId) {
    return buildWorkspacePath(organizationSlug, workspaceId, normalizedPath)
  }

  return `/${organizationSlug}${normalizedPath}`
}
